<template>
  <ConfirmActionDialog
    :model-value="modelValue"
    :title="title"
    description="Confirm you understand that adding this account to the meter exchange journey will:"
    :bullet-points="[
      'Create a meter exchange ticket for the account',
      'Regularly send the account to Engage through the exchange placement file until the ticket signals otherwise',
      'Trigger top-up comms to be sent to the customer as required',
    ]"
    confirm-title="Add to meter exchange journey"
    test-id="add-to-meter-exchange-journey"
    :loading="loading"
    @update:model-value="$emit('update:modelValue', $event)"
    @confirm="$emit('confirm')"
  />
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import ConfirmActionDialog from "./ConfirmActionDialog.vue"

  export default defineComponent({
    components: {
      ConfirmActionDialog,
    },
    props: {
      modelValue: {
        type: Boolean,
        required: true,
      },
      accountNumber: {
        type: String,
        required: true,
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["update:modelValue", "confirm"],
    computed: {
      title(): string {
        return `Add Account ${this.accountNumber} to meter exchange journey`
      },
    },
  })
</script>
